import React, { useEffect, useState } from "react";
import MobileClaimSuccess from "../../components/patient/MobileClaimSuccess";
import { useParams } from "react-router-dom";
import { errorMessage } from "../../utils/notificationUtils";
import { getPatientBasicDetails } from "../../apis/patientService";

const MobileClaimSuccessContainer = () => {
  const { visitId } = useParams();
  const [visitDetails, setVisitDetails] = useState<any>(null);
  const [loadingClaim, setLoadingClaim] = useState(false);

  const fetchVisitDetails = async () => {
    try {
      const res = await getPatientBasicDetails(visitId);
      setVisitDetails(res?.fetchBasicDetail);
    } catch (err) {
      errorMessage("Please, Try again later.");
    }
  };

  // useEffect(() => {
  //   if (visitId) {
  //     fetchVisitDetails();
  //   }
  // }, [visitId]);

    useEffect(() => {
    let interval: any;
    let elapsed = 0;

    const startPolling = async () => {
      const res = await getPatientBasicDetails(visitId);
      const data = res?.fetchBasicDetail;
      setVisitDetails(res?.fetchBasicDetail);

      const scheme = data?.casesResponse?.schemeMetaDataName?.toLowerCase();

      if (scheme?.includes("echs") && !data?.visitInfoResponse?.claimId) {
        setLoadingClaim(true);

        interval = setInterval(async () => {
          elapsed += 5;

          const res = await getPatientBasicDetails(visitId);
          const updated = res?.fetchBasicDetail;
          setVisitDetails(res?.fetchBasicDetail);

          if (updated?.visitInfoResponse?.claimId || elapsed >= 30) {
            clearInterval(interval);
            setLoadingClaim(false);
          }
        }, 5000);
      }
    };

    if (visitId) {
      startPolling();
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [visitId]);

  return (
    <div>
      <MobileClaimSuccess
        claimId={visitDetails?.visitInfoResponse?.claimId}
        creditNumber={visitDetails?.visitInfoResponse?.creditNumber}
        schemeName={visitDetails?.casesResponse?.schemeMetaDataName}
        loadingClaim={loadingClaim}
      />
    </div>
  );
};

export default MobileClaimSuccessContainer;
